import { defineMessages } from 'react-intl';

export default defineMessages({
  deliveryAmountFree: {
    id: 'card.deliveryAmountFree',
    defaultMessage: 'Envío gratis',
  },
  deliveryAmount: {
    id: 'card.deliveryAmount',
    defaultMessage: 'Envío {deliveryAmount}',
  },
  deliveryAmountVariable: {
    id: 'card.deliveryAmountVariable',
    defaultMessage: 'Envío variable',
  },
  deliveryOriginalAmount: {
    id: 'card.deliveryOriginalAmount',
    defaultMessage: '{deliveryAmount}',
  },
});
